import React, { useState } from "react";
import { Toaster, toast } from "react-hot-toast";
import { resetPassword } from "../Services/APIService";

interface PasswordResponse {
  message?: string;
  isUpdated: boolean;
}

interface UserPasswordModalProps {
  isOpen: boolean;
  onClose: () => void;
  userId: number;
}

const UserPasswordModal: React.FC<UserPasswordModalProps> = ({
  isOpen,
  onClose,
  userId,
}) => {
  const [newPassword, setNewPassword] = useState<string>("");
  const [confirmPassword, setConfirmPassword] = useState<string>("");
  const [error, setError] = useState<string>("");
  const [success, setSuccess] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);

  if (!isOpen) return null;

  const handleUpdatePassword = async (): Promise<void> => {
    setError("");
    setSuccess("");

    if (newPassword !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    if (!passwordRegex.test(newPassword)) {
      setError(
        "Password must contain at least 8 characters, including uppercase, lowercase, number, and special character"
      );
      return;
    }

    try {
      setLoading(true);
      const payload = {
        userID: userId,
        password: newPassword,
      };

      const result = await resetPassword(payload);

      if (!result.isUpdated) {
        const errorData: PasswordResponse = await result.json();
        throw new Error(errorData.message || "Failed to update password");
      } else {
        toast.success(result.message || "Password Updated Successfully!");
        setSuccess(result.message || "Password Updated Successfully!");
        setNewPassword("");
        setConfirmPassword("");
        setTimeout(() => {
          onClose();
        }, 100);
      }
    } catch (err) {
      setError(
        err instanceof Error ? err.message : "Failed to update password"
      );
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setNewPassword("");
    setConfirmPassword("");
    setError("");
    setSuccess("");
    onClose();
  };

  return (
    <div className="modal-overlay">
      <div>
        <Toaster position="top-center" reverseOrder={false} />
      </div>
      <div className="changepassword-modal-content modal-content">
        <button className="close-button" onClick={handleClose}>
          ×
        </button>
        <h1 className="h3 mb-3">
          <strong>Change</strong> User Password
        </h1>
        {error && (
          <div className="error-message text-danger message">{error}</div>
        )}
        {success && (
          <div className="success-message text-success message">{success}</div>
        )}

        <div className="form-group">
          <label className="form-label" htmlFor="newUserPassword">
            New Password
          </label>
          <input
            type="password"
            id="newUserPassword"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            placeholder="Enter new password"
            disabled={loading}
            className="form-control form-control-lg"
          />
        </div>

        <div className="form-group mt-2">
          <label className="form-label" htmlFor="confirmUserPassword">
            Confirm Password
          </label>
          <input
            type="password"
            id="confirmUserPassword"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            placeholder="Confirm new password"
            disabled={loading}
            className="form-control form-control-lg"
          />
        </div>

        <button
          className="update-button btn btn-primary mt-3"
          onClick={handleUpdatePassword}
          disabled={loading}
        >
          {loading ? "Updating..." : "Update Password"}
        </button>
        {/* <button
    className="btn btn-secondary mt-3 mx-2"
    onClick={handleClose}
    disabled={loading}
  >
    Cancel
  </button> */}
      </div>
    </div>
  );
};

export default UserPasswordModal;
